import React from 'react';

export const renderWithLineBreaksAndBold = (text) => {
    const lines = text.split('\n');
    return lines.map((line, lineIndex) => {
        // splits  Hey there! **Glad** you could make it. -> ["Hey there!", "**Glad**", "you could make it"]
        const b_splits = line.split(/(\*\*[^*]+\*\*)/g);
        const newLine = b_splits.map((b_split, i) => {
            // here we get rid of ** ** and simply place <b> </b> instead
            if (/^\*\*[^*]+\*\*$/.test(b_split)) {
                return <b key={i}>{b_split.slice(2, -2)}</b>;
            }
            return <React.Fragment key={i}>{b_split}</React.Fragment>;
        });
        return (
            <React.Fragment key={lineIndex}>
            {newLine}
            <br />
            </React.Fragment>
        );
    });
};